import { createWithEqualityFn } from 'zustand/traditional';
import { getUserinfo } from '@shakkerai/business-userinfo';
import { config } from '@shakkerai/config';

export const useUserInfo = createWithEqualityFn((set, get) => ({
  userInfo: null,
  __initialized: false,
  updateUserInfo: (partialUserInfo, override = false) => {
    set(override ? partialUserInfo : Object.assign({ __initialized: true }, get(), partialUserInfo), override);
  },
  removeUserInfo: () => set({ userInfo: null }),
}));

export const useUserInfoUpdater = (selector) => {
  return useUserInfo(selector, () => true);
};

export const initUserInfo = async (isForced) => {
  const { data: userInfo } = await getUserinfo(isForced);

  if (!userInfo) {
    if (!isForced) {
      useUserInfo.setState({ __initialized: true });
      return { __initialized: true };
    }
    if (!['/pro', '/aigenerator'].includes(window.location.pathname)) {
      window.location.href = '/';
    }
    return;
  }

  useUserInfo.setState({ userInfo, __initialized: true });
  return { userInfo, __initialized: true };
};
